<script>
  import { ignore } from "../../Common/tools";
  import  { M } from "../../external"

  export let onOptionSelected = ignore;

  let onSelect = (type) => {
    onOptionSelected(type === "blank" ? -1 : 1);
  };
</script>

<h3 class="roboto col20 f-left t-center mt-35">{M.SELECT_AUTOMATION_FLOW}</h3>
<div class="col20 flex f-left t-center justify-center" style="padding: 20px 35px 35px; box-sizing: border-box;">
  <a class="addon-select half-select" style="max-width: 300px;" on:click={() => onSelect("blank")}>
    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M2,4v16h20V4H2z M20,18H4V6h16V18z"/></g></g></svg>
    <h4 class="col20 f-left mt-15">{M.BLANK_AUTOMATION}</h4>
    <span class="col20 f-left t-center light-gray-text">{M.BLANK_AUTOMATION_DESC}</span>
  </a>
  <a class="addon-select half-select" style="max-width: 300px;" on:click={() => onSelect("abandoned")}>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zM20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z" />
    </svg>
    <h4 class="col20 f-left mt-15">{M.ABANDONED_CART_AUTOMATION}</h4>
    <span class="col20 f-left t-center light-gray-text">{M.ABANDONED_CART_AUTOMATION_DESC}</span>
  </a>
</div>
